<template>
  <v-select
    v-model="select"
    :items="items"
    @change="setSelectResult"
    prepend-icon="mdi-list-status"
    item-text="text"
    item-value="result"
    :label="$t('result')"
    filled
    hide-details
    solo-inverted
  ></v-select>
</template>
<script>
export default {
  name: "components-agent-backoffice-filters_global-select-result-bet",
  data: () => ({
    select: {},
    items: [],
  }),
  computed: {
    permission_reward() {
      return this.$store.state.permission_reward;
    },
  },
  mounted() {
    this.items = [
      {
        text: this.$t("selectAllbetOnline"),
        result: this.permission_reward == "1" ? "4" : "3",
      },
      {
        text: this.$t("pendent"),
        result: "2",
      },
      {
        text: this.$t("lost"),
        result: "0",
      },
      
    ];
    if(this.permission_reward == 1) {
      this.items.push({text: this.$t("awarded"),result: "1",})
    }
    this.select = {
      text: this.$t("selectAllbetOnline"),
      result: this.permission_reward == 1 ? "4" : "3",
    };

    if (this.$isCreditOnline()) {
      this.items.push({ text: this.$t("finishedPlural"), result: 5 });
    }
  },
 
  watch: {
    permission_reward(val) {
      if (val === "1") {
        // Se o agente tem permissão para vizualizar apostas vencedoras recebe status "4" para Todas  (Pendentes, Perdidas, Premiadas)
        // Recebe também o item de apostas premiadas com status "1
        this.items[0] = {text: this.$t("selectAllbetOnline"), result: "4",};
        this.items.push({text: this.$t("awarded"),result: "1",})
        this.select = {text: this.$t("selectAllbetOnline"), result: "4",};
    } else if (val === "0") {
        // Se o agente tem permissão para vizualizar apostas vencedoras recebe status "3" para Todas (Pendentes e Perdidas apenas)
        this.items[0] = {text: this.$t("selectAllbetOnline"), result: "3",};
        this.select = {text: this.$t("selectAllbetOnline"), result: "3",};
      if (this.items.some((item) => item.result === "1")) {
        // Esse agente não tem acesso as apostas premiadas, remove o ultimo item do array (Premiadas)
        this.items.pop();
      }
    } 
    this.setSelectResult(this.items[0].result) 
    },
  },
  methods: {
    setSelectResult(result) {
      this.$store.commit("setSelectResultBet", result);
    },
  },
};
</script>
